import { render, staticRenderFns } from "./kinozal.vue?vue&type=template&id=2dc2a413&scoped=true&"
import script from "./kinozal.vue?vue&type=script&lang=js&"
export * from "./kinozal.vue?vue&type=script&lang=js&"
import style0 from "./kinozal.vue?vue&type=style&index=0&id=2dc2a413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2a413",
  null
  
)

export default component.exports